/** @format */

import { post, download } from '@root/utils/httpWrap';
import e from 'express';
// import { setHttp } from '@root/utils/http'

// const http = setHttp({}, 'v2')

/**
 * 车位资源管理列表
 */
export const queryParkingSpaceList = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/list', params);
};
/**
 * c端配置保存
 */
export const editCService = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/editCService', params);
};
/**
 * 车位资源获取区域列表
 */
export const queryParkingSpaceAreaInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/getAreaInfo', params);
};

/**
 * 车位资源管理列表详情
 */
export const queryParkingSpaceDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/detail', params);
};

/**
 * 车位资源管理编辑详情
 */
export const queryParkingSpaceEditInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/getEditInfo', params);
};

/**
 * 车位资源管理新增和修改
 */
export const queryParkingSpaceAddUpdate = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/editOrAdd', params);
};

/**
 * 车位资源管理转让详情
 */
export const queryParkingSpaceTransferInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/transferInfo', params);
};

/**
 * 车位资源管理转让
 */
export const queryParkingSpaceTransfer = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/transfer', params);
};

/**
 * 车位操作记录列表
 */
export const queryParkingSpaceRecord = (params: any): any => {
  return post('/bangdao/saasapi/v1/spaceRecord/list', params);
};

/**
 * 车位套餐收费记录列表
 */
export const queryParkingSpacePackageRecord = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackageRecord/list', params);
};

/**
 * 车位固定收费套餐列表
 */
export const queryParkingspacePackageList = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/list', params);
};

/**
 * 车位固定收费 审核或发售
 */
export const queryParkingspacePackageAuditOrSale = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/auditOrSale', params);
};

/**
 * 车位固定收费 删除
 */
export const queryParkingspacePackageDelete = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/delete', params);
};

/**
 * 车位固定收费 修改详情
 */
export const queryParkingspacePackageEditInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/getEditInfo', params);
};

/**
 * 车位固定收费 新增
 */
export const queryParkingspacePackageAdd = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/add', params);
};

/**
 * 车位固定收费 修改
 */
export const queryParkingspacePackageEdit = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/edit', params);
};
/**
 * 车位资源 下载模板
 */
export const downloadTemplate = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/space/template', params, fileName);
};
/**
 * 车位资源 导出
 */
export const spaceExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/space/export', params, fileName);
};
/**
 * 车位资源 批量删除
 */
export const spaceDelete = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/delete', params);
};

/**
 * 车位数量增加
 */
export const autoSpaceList = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/autoSpaceList', params);
};

/**
 * 车位新增
 */
export const batchAdd = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/batchAdd', params);
};

/**
 * 车位获取区域
 */
export const getAreaList = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/getAreaList', params);
};

/**
 * 获取用户姓名模糊查询list
 */
export const getUserList = (params: any): any => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve({
        status: '9999',
        data: [{ id: 1, name: 'jack' }, { id: 2, name: 'jack2' }]
      });
    }, 1000);
  });
};

/**
 * 获取房号模糊查询list
 * @param {"parkId":"","searchParam":"八号楼"}
 */
export const getRoomList = ({ parkId, searchParam }: { parkId: string; searchParam: string }) => {
  return post('/bangdao/saasapi/v1/monthCard/selectRoom', { parkId, searchParam });
  // return new Promise(resolve => {
  //   setTimeout(() => {
  //     resolve({
  //       status: '9999',
  //       data: [{ roomId: 1, roomName: 'jack' }, { roomId: 2, roomName: 'jack2' }],
  //     })
  //   }, 600)
  // })
};

/**
 * 获取房号模糊查询list
 * @param {"roomId":"81810"}
 */
export const getUserByRoomID = (roomId: string) => {
  return post('/bangdao/saasapi/v1/monthCard/selectUserInfo ', { roomId });
  // return new Promise(resolve => {
  //   setTimeout(() => {
  //     resolve({
  //       status: '9999',
  //       data: {
  //         ownerName: 'jack2',
  //         mobile: '15555555555',
  //       },
  //     })
  //   }, 600)
  // })
};
